import React from 'react';
export function EliteSection() {
  return <section className="w-full bg-[#1a0f00] py-16 px-4" data-id="element-73">
      <div className="max-w-4xl mx-auto" data-id="element-74">
        <div className="text-center mb-10" data-id="element-75">
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-4" data-id="element-76">
            🥊 ¿QUÉ AGREGA EL{' '}
            <span className="text-[#F97316]" data-id="element-77">MÉTODO GYM LLENO™</span>?
          </h2>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto" data-id="element-78">
            El sistema de negocio que hace que el gym se llene y se mantenga
            lleno
          </p>
        </div>

        {/* Comparison Table */}
        <div className="bg-black border border-[#F97316]/30 rounded-2xl overflow-hidden mb-12" data-id="element-79">
          <div className="grid grid-cols-1 sm:grid-cols-3 bg-[#0d0700] border-b border-[#F97316]/30" data-id="element-80">
            <div className="p-4 font-bold text-white hidden sm:block" data-id="element-81">
              Situación
            </div>
            <div className="p-4 font-bold text-gray-400 text-center border-l border-[#F97316]/30" data-id="element-82">
              Sin Método Gym Lleno
            </div>
            <div className="p-4 font-bold text-[#F97316] text-center border-l border-[#F97316]/30" data-id="element-83">
              Con Método Gym Lleno
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-84">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-85">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-86">
                Situación:
              </span>
              Tu precio
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-87">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-88">
                Sin Método Gym Lleno:
              </span>
              Lo mismo que cobra el de enfrente
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#F97316]/5" data-id="element-89">
              <span className="sm:hidden font-bold text-[#F97316] block mb-1" data-id="element-90">
                Con Método Gym Lleno:
              </span>
              Estructura de precios élite con 3 niveles
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-91">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-92">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-93">
                Situación:
              </span>
              Cuando alguien pregunta el precio
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-94">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-95">
                Sin Método Gym Lleno:
              </span>
              "Son $X por mes... ¿está bien?"
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#F97316]/5" data-id="element-96">
              <span className="sm:hidden font-bold text-[#F97316] block mb-1" data-id="element-97">
                Con Método Gym Lleno:
              </span>
              Script de cierre que convierte el 70%+
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-98">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-99">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-100">
                Situación:
              </span>
              Primera clase de un nuevo alumno
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-101">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-102">
                Sin Método Gym Lleno:
              </span>
              "Vení a probar y ves cómo te va"
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#F97316]/5" data-id="element-103">
              <span className="sm:hidden font-bold text-[#F97316] block mb-1" data-id="element-104">
                Con Método Gym Lleno:
              </span>
              Sistema de Primera Victoria que fideliza
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-105">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-106">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-107">
                Situación:
              </span>
              Alumnos que se van sin avisar
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-108">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-109">
                Sin Método Gym Lleno:
              </span>
              Te enterás cuando ya se fueron
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#F97316]/5" data-id="element-110">
              <span className="sm:hidden font-bold text-[#F97316] block mb-1" data-id="element-111">
                Con Método Gym Lleno:
              </span>
              Semáforo Verde/Amarillo/Rojo con protocolo
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-112">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-113">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-114">
                Situación:
              </span>
              Marketing
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-115">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-116">
                Sin Método Gym Lleno:
              </span>
              Boca en boca y rezar
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#F97316]/5" data-id="element-117">
              <span className="sm:hidden font-bold text-[#F97316] block mb-1" data-id="element-118">
                Con Método Gym Lleno:
              </span>
              4 canales activos + Google Maps optimizado
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-119">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-120">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-121">
                Situación:
              </span>
              Identidad
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-122">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-123">
                Sin Método Gym Lleno:
              </span>
              "Soy profe de boxeo"
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#F97316]/5" data-id="element-124">
              <span className="sm:hidden font-bold text-[#F97316] block mb-1" data-id="element-125">
                Con Método Gym Lleno:
              </span>
              "Soy dueño de un negocio de transformación"
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-126">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-127">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-128">
                Situación:
              </span>
              Ingresos
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-129">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-130">
                Sin Método Gym Lleno:
              </span>
              Variables e impredecibles
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#F97316]/5" data-id="element-131">
              <span className="sm:hidden font-bold text-[#F97316] block mb-1" data-id="element-132">
                Con Método Gym Lleno:
              </span>
              Sistema de membresías con ingresos estables
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3" data-id="element-133">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-134">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-135">
                Situación:
              </span>
              Referidos
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-136">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-137">
                Sin Método Gym Lleno:
              </span>
              Los que llegan solos
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#F97316]/5" data-id="element-138">
              <span className="sm:hidden font-bold text-[#F97316] block mb-1" data-id="element-139">
                Con Método Gym Lleno:
              </span>
              Sistema estructurado que los multiplica
            </div>
          </div>
        </div>

        {/* Features List */}
        <h3 className="text-2xl font-black text-white text-center mb-8" data-id="element-140">
          ✅ MÉTODO GYM LLENO™ INCLUYE:
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-141">
          <div className="bg-black border border-[#F97316]/20 rounded-xl p-5" data-id="element-142">
            <h4 className="text-[#F97316] font-bold text-lg mb-2" data-id="element-143">
              💰 Módulo 1 — Estructura de Precios Élite
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-144">
              Cómo calcular y cobrar lo que realmente vale tu trabajo
            </p>
          </div>
          <div className="bg-black border border-[#F97316]/20 rounded-xl p-5" data-id="element-145">
            <h4 className="text-[#F97316] font-bold text-lg mb-2" data-id="element-146">
              🏆 Módulo 2 — Sistema de Membresías
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-147">
              Base / Pro / VIP: tres niveles, tres experiencias
            </p>
          </div>
          <div className="bg-black border border-[#F97316]/20 rounded-xl p-5" data-id="element-148">
            <h4 className="text-[#F97316] font-bold text-lg mb-2" data-id="element-149">
              🧲 Módulo 3 — Imán de Alumnos Nuevos
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-150">
              El sistema de captación que trabaja mientras entrenás
            </p>
          </div>
          <div className="bg-black border border-[#F97316]/20 rounded-xl p-5" data-id="element-151">
            <h4 className="text-[#F97316] font-bold text-lg mb-2" data-id="element-152">
              🎯 Módulo 4 — La Clase de Prueba que Convierte
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-153">
              De 20% a 70%+ de conversión con un solo cambio
            </p>
          </div>
          <div className="bg-black border border-[#F97316]/20 rounded-xl p-5" data-id="element-154">
            <h4 className="text-[#F97316] font-bold text-lg mb-2" data-id="element-155">
              📱 Módulo 5 — Marketing Local Pro
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-156">
              Instagram + Google Maps + WhatsApp Business
            </p>
          </div>
          <div className="bg-black border border-[#F97316]/20 rounded-xl p-5" data-id="element-157">
            <h4 className="text-[#F97316] font-bold text-lg mb-2" data-id="element-158">
              🔒 Módulo 6 — Retención de Acero
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-159">
              Que tus alumnos se queden 3 años, no 3 meses
            </p>
          </div>
          <div className="bg-black border border-[#F97316]/20 rounded-xl p-5" data-id="element-160">
            <h4 className="text-[#F97316] font-bold text-lg mb-2" data-id="element-161">
              🤝 Módulo 7 — Sistema de Referidos
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-162">
              Que cada alumno traiga 2 más sin pedírselo
            </p>
          </div>
          <div className="bg-black border border-[#F97316]/20 rounded-xl p-5" data-id="element-163">
            <h4 className="text-[#F97316] font-bold text-lg mb-2" data-id="element-164">
              ⚖️ Módulo 8 — Protección Legal
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-165">
              Los 5 documentos que protegen tu gym
            </p>
          </div>
          <div className="bg-black border border-[#F97316]/20 rounded-xl p-5" data-id="element-166">
            <h4 className="text-[#F97316] font-bold text-lg mb-2" data-id="element-167">
              📊 Módulo 9 — Calculadora de Rentabilidad
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-168">
              Cuánto deberías ganar y cuánto estás dejando
            </p>
          </div>
          <div className="bg-black border border-[#F97316]/20 rounded-xl p-5" data-id="element-169">
            <h4 className="text-[#F97316] font-bold text-lg mb-2" data-id="element-170">
              🗓️ Módulo 10 — Plan de 90 Días
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-171">
              Semana a semana para implementar todo
            </p>
          </div>
        </div>
      </div>
    </section>;
}